import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background-color: #f8f9fa;
`;

export const Title = styled.h1`
  color: #cf0505;
  margin: 24px 0 12px;
  text-align: center;
  font-size: 24px;
`;

export const TopActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  padding: 0 16px;

  button {
    padding: 6px 12px;
    font-size: 14px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    background-color: #003366;
    color: white;

    &:hover {
      background-color: #002244;
    }

    &:disabled {
      background-color: #ccc;
      cursor: not-allowed;
    }
  }
`;

export const ActionInputWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 12px 16px;

  input {
    max-width: 300px;
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 14px;
  }
`;

export const ScrollableTableArea = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 16px 16px;
  width: 100%;

  @media (max-width: 768px) {
    padding-bottom: 80px; // espaço extra p/ footer mobile
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  border-radius: 8px;
  background: white;

  th, td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    font-size: 14px;
  }

  th {
    background-color: #f0f0f0;
    color: #333;
  }

  tr:nth-child(even) {
    background-color: #f9f9f9;
  }

  tr:hover {
    background-color: #f1f1f1;
  }
`;

export const EditButton = styled.button`
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: #1e40af;
  }
`;


export const BackButton = styled.button`
    position: absolute;
    top: 100px;
    left: 20px;
    background-color: transparent;
    border: none;
    font-size: 16px;
    color: #cf0505;
    cursor: pointer;
    display: flex;
    align-items: center;

    &:hover {
        color: #800000;
    }
`;            